// import { gsap } from 'gsap';

export default class Logo {
  constructor() {
    this.svg = document.querySelector('.main-header .logo-area svg');
    this.shape = this.svg.querySelector('#logo_dreamcatcher');
    this.title = this.svg.querySelector('#logo_title');
    this.subtitle = this.svg.querySelector('#logo_subtitle');
    this.mobileWidth = 992;
    this.init();
    this.events();
  }

  init() {

    this.shape.style.transformOrigin = '30px center';
    // console.log(this.shape);
    // console.log(this.title);
    // console.log(this.subtitle);
  }

  onStickyHeaderShow(ev) {
    const offset = this.mobileWidth < window.innerWidth ? '-26px' : '-16px';
    gsap.to(this.svg, {duration: .3, y: offset });
    gsap.to(this.shape, { duration: .3, scale: 2.5, y: '64px', ease: 'power3.inOut' });
    gsap.to(this.subtitle, { duration: .3, y: '-8px', ease: 'power3.inOut' });
    gsap.to(this.title, { duration: .3, y: '-8px', ease: 'power3.inOut' });

    this.title.querySelectorAll('path').forEach(item => {
      item.style.fill = 'var(--bs-dark)';
    });

    this.subtitle.querySelectorAll('path').forEach(item => {
      item.style.fill = 'var(--bs-dark)';
    });

    this.shape.querySelectorAll('path').forEach(item => {
      item.style.fill = 'var(--bs-dark)';
      item.style.opacity = '0.1';
    });
  }

  onStickyHeaderHide(ev) {
    const offset = this.mobileWidth < window.innerWidth ? '24px' : '34px';
    gsap.to(this.svg, {duration: .3, y: offset });
    gsap.to(this.shape, { duration: .3, scale: 1, y: 0, ease: 'power3.inOut' });
    gsap.to(this.subtitle, { duration: .3, y: 0, ease: 'power3.inOut' });
    gsap.to(this.title, { duration: .3, y: 0, ease: 'power3.inOut' });

    this.title.querySelectorAll('path').forEach(item => {
      item.style.fill = 'var(--bs-white)';
    });

    this.subtitle.querySelectorAll('path').forEach(item => {
      item.style.fill = 'var(--bs-white)';
    });

    this.shape.querySelectorAll('path').forEach(item => {
      item.style.fill = 'var(--bs-white)';
      item.style.opacity = '1';
    });
  }

  events() {
    window.addEventListener('stickyHeader.show', this.onStickyHeaderShow.bind(this));
    window.addEventListener('stickyHeader.hide', this.onStickyHeaderHide.bind(this));
  }
}
